import type { TPageTranslations } from '@crehana/i18n';

import { ATS_CAREER_SITE_ADMIN_SHARED } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof ATS_CAREER_SITE_ADMIN_SHARED> =
  {
    [ATS_CAREER_SITE_ADMIN_SHARED]: {
      RECRUITMENT: 'Recrutamento',
      CAREER_SITE: 'Portal de emprego',
      SUBTITLE_CAREER_SITE:
        'Configure e personalize seu portal de emprego para exibir suas vagas e atrair os melhores candidatos.',
      BANNER_TOP_TEXT:
        'As ofertas de emprego são demonstrativas e servem apenas para que você tenha uma ideia da aparência do portal.',
      VACANCY: 'Vaga',
      DEPARTMENT: 'Departamento',
      POSITION: 'Cargo',
      CLOSED_DATE: 'Data de fechamento',
      PUBLISHED_DATE: 'Publicado há {{days}} dias',
      SEARCH_BY_NAME: 'Buscar por nome',
      DAY: 'dia',
      MONTH: 'mês',
      YEAR: 'ano',
      DAYS: 'dias',
      MONTHS: 'meses',
      YEARS: 'anos',
      CLOSED_DATE_CARD: 'Data de fechamento: {{date}}',
      FILTER_BY: 'Filtrar por',
      SEARCH_BY_DEPARTMENT: 'Buscar por departamento',
      NO_DEPARTMENTS_FOUND: 'Não foram encontrados departamentos',
      TRY_ANOTHER_SEARCH: 'Tentar outra busca',
      VACANCY_EXAMPLE: 'Vaga de exemplo',
      OPEN_DATE_EXAMPLE: 'Publicado há 3 dias',
      DEPARTMENT_EXAMPLE: 'Departamento de exemplo',
      FAILED_TO_EXTRACT_JOB_ID_FROM_VACANCY_LINK:
        'Não foi possível redirecionar para o formulário de postulação',
      VACANCY_LINK_IS_EMPTY:
        'Não foi possível redirecionar para o formulário de postulação',
    },
  };
